import 'regenerator-runtime';
import { put } from 'redux-saga/effects';
import {
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
} from '../actions/actionTypes';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { convertObjectToQueryParams, updateCurrencyCode } from 'src/utils/util';
import { getPricesForItemsDataService } from 'src/pages/equity/services';
import { getPricesForItemsEndpoint } from 'src/pages/equity/services/endpoints';
import { getBannerDetails } from 'src/common/redux/actions';

const getParams = ({ products, orderType, sapPartnerId, bundleProducts, billToId, districtId,territoryId  }) => {
    const salesOrgList = [];
    products &&
        products.forEach((product) => {
            product.productCFN
                ? salesOrgList.push(product.productCFN)
                : salesOrgList.push(product.cfn);
        });
    return convertObjectToQueryParams({
        productCFN: salesOrgList.join(),
        sapPartnerId,
        orderType,
        bundleProducts,
        billToId,
        districtId,
        territoryId
    });
};

export default function* getPricesForEquityItemSaga(action) {
    const params = getParams(action.payload);
    const fromSearch = action.payload?.fromSearch || false;
    try {
        yield put(getBannerDetails());
        const response = yield getPricesForItemsDataService(
            params
            // convertObjectToQueryParams(action.payload)
        );
        localStorage.setItem('currencyISOCode', response.priceDetails[0]?.currencyISOCode);
        updateCurrencyCode(response.priceDetails[0]?.currencyISOCode);
        yield put({
            type: GET_PRICES_FOR_ITEMS_SUCCESS,
            payload: {
                items: response.priceDetails,
                isPricingDone: true,
                fromSearch,
            },
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: getPricesForItemsEndpoint(params),
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRICES_FOR_ITEMS_FAILURE,
            payload: { items: [], isPricingDone: false },
        });
    }
}
